import { render, staticRenderFns } from "./ReportPartialInvoiceConsumption.vue?vue&type=template&id=1954bc4c"
import script from "./ReportPartialInvoiceConsumption.vue?vue&type=script&lang=js"
export * from "./ReportPartialInvoiceConsumption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports